// src/components/ui/feedback/SuccessScreen/SuccessScreen.jsx
import React from 'react';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { cn } from '../../../../utils/cn';

const SuccessScreen = ({
  icon: Icon = CheckCircle2,
  title,
  message,
  footerText,
  footerIcon: FooterIcon = Sparkles,
  iconGradient = "from-emerald-500 to-green-600",
  iconShadow = "shadow-emerald-500/25",
  className = ''
}) => {
  return (
    <div className={cn("text-center", className)}>
      {/* Large Success Icon */}
      <div className={cn(
        "inline-flex items-center justify-center w-20 h-20 rounded-2xl mb-6 shadow-lg",
        `bg-gradient-to-br ${iconGradient}`,
        iconShadow
      )}>
        <Icon className="w-10 h-10 text-white" />
      </div>
      
      {/* Success Title */}
      {title && (
        <h1 className="text-2xl font-bold bg-gradient-to-r from-slate-100 to-slate-300 bg-clip-text text-transparent mb-4">
          {title}
        </h1>
      )}
      
      {/* Success Message */}
      {message && (
        <p className="text-slate-400 mb-6">
          {message}
        </p>
      )}
      
      {/* Footer Text with Icon */}
      {footerText && (
        <div className="inline-flex items-center gap-2 text-emerald-400 text-sm">
          {FooterIcon && <FooterIcon className="w-4 h-4" />}
          {footerText}
        </div>
      )}
    </div>
  );
};

export default SuccessScreen;